import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import AddressFields from './AddressFields';
import { CloseIcon } from '../../../../assets/icons';
import { updateUserProfile } from '../../../../services/authApi/userApi';
import { toastNotify } from '../../../../utils/toastNotify';
import { addUserData } from '../../../../store/reducer/accountSlice';
import { resolveStateId } from '../../../../utils/statesCache';

const EditEntityAddress = (props) => {
  const [address, setAddress] = useState();
  const [aptNumber, setAptNumber] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState(undefined);
  const [originalStateId, setOriginalStateId] = useState(undefined);
  const [zipCode, setZipCode] = useState();
  const [country, setCountry] = useState('unitedstates');
  const [isEdit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { entityAddressData } = props;
  const dispatch = useDispatch();
  const [arrowUp, setArrowUp] = useState(false);
  const [isChangedValue, setIsChangedValue] = useState(false);

  useEffect(() => {
    handleSetDefaultData();
  }, [entityAddressData]);

  const handleSetDefaultData = async () => {
    if (entityAddressData && Object.keys(entityAddressData).length > 0) {
      const { residentialAdd, apartmentNumber, city, zipCode } = entityAddressData;
      const entityStateId = await resolveStateId(entityAddressData?.state);
      form.setFieldsValue({
        address: residentialAdd,
        aptNumber: apartmentNumber,
        city: city,
        state: entityStateId,
        zipcode: zipCode,
      });
      setAddress(residentialAdd);
      setAptNumber(apartmentNumber);
      setCity(city);
      setState(entityStateId);
      setOriginalStateId(entityStateId);
      setZipCode(zipCode);
      setEdit(true);
    }
  };

  const onEditEntityAddressSubmit = async (values) => {
    setLoading(true);
    const { address, aptNumber, city, zipcode } = values;
    const entityAddressFormData = {
      entityAddress: {
        residentialAdd: address,
        city: city,
        state: state ? state?.toString() : originalStateId?.toString(),
        zipCode: zipcode,
      },
    };
    if (aptNumber) entityAddressFormData['entityAddress']['apartmentNumber'] = aptNumber;
    try {
      const resp = await updateUserProfile(entityAddressFormData);
      if (!resp.isError) {
        dispatch(addUserData({ userData: resp?.data?.user }));
        props.setClose();
        toastNotify('success', 'Entity address updated successfully.');
      } else {
        toastNotify('error', resp?.message || 'Failed to update entity address. Please try again.');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message || 'Failed to update entity address. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckChanges = (values) => {
    if (
      values?.address !== entityAddressData?.residentialAdd ||
      values?.aptNumber !== entityAddressData?.apartmentNumber ||
      values?.city !== entityAddressData?.city ||
      (state && Number(values?.state) !== Number(originalStateId)) ||
      values?.zipcode !== entityAddressData?.zipCode
    ) {
      setIsChangedValue(true);
    } else {
      setIsChangedValue(false);
    }
  };

  return (
    <Modal
      className='account__modal'
      open={props.setOpen}
      onCancel={() => {
        handleSetDefaultData();
        props.setClose();
      }}
      width={524}
      footer={false}
      closeIcon={<CloseIcon />}
      centered
    >
      <h4 className='mb-32 account__modal__title'>Edit entity address</h4>
      <Form
        onFieldsChange={() => handleCheckChanges(form.getFieldValue())}
        onSelect
        name='editEntityAddressForm'
        form={form}
        onFinish={onEditEntityAddressSubmit}
        autoComplete='off'
      >
        <AddressFields
          addressLabel='Entity address'
          addressRequiredMessage='Please enter Entity address'
          addressInvalidMessage='Address must be a valid address.  P.O. Box addresses are not allowed'
          addressLengthMessage='Please provide a valid address value. Address length should be between 2 and 49.'
          aptNumberInvalidMessage='Address must be a valid address. P.O. Box addresses are not allowed'
          countryAnchorId='entity-country-anchor'
          address={address}
          setAddress={setAddress}
          aptNumber={aptNumber}
          setAptNumber={setAptNumber}
          city={city}
          setCity={setCity}
          state={state}
          setState={setState}
          zipCode={zipCode}
          setZipCode={setZipCode}
          country={country}
          setCountry={setCountry}
          isEdit={isEdit}
          arrowUp={arrowUp}
          setArrowUp={setArrowUp}
        />
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0'>
              <Button
                className='w-100'
                onClick={() => {
                  props.setClose();
                  handleSetDefaultData();
                }}
              >
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={24} sm={12}>
            <Form.Item className='mb-0' shouldUpdate>
              {() => (
                <Button
                  className='w-100'
                  type='primary'
                  htmlType='submit'
                  loading={loading}
                  disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length || !isChangedValue}
                >
                  Save
                </Button>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditEntityAddress;
